export default __webpack_public_path__ + "static/media/Insta3.07adee3b.png";